import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async saveTurma({ commit }, data) {
      try {
        return await api.post('/turmas', data)
      } catch (error) {
        throw error
      }
    },

    async getTurmas({ commit }, data) {
      try {
        let url = `/turmas`

        if (data && data.status) {
          url += `?status=${data.status}`
        }

        const response = await api.get(url)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getTurma({ commit }, turmaId) {
      try {
        const response = await api.get(`/turmas/${turmaId}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateTurma({ commit }, data) {
      try {
        return await api.put(`/turmas/${data.id}`, data.turma)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
